import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { Filters } from './filters';
const footerCss = "ft0hxnx";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
const resetButtonWrapperCss = "r4wwtjf";
const ResetButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(resetButtonWrapperCss, props.className)} />;
});
export const DropdownContent = ({
  initialHostIds,
  initialOwnerIds,
  initialUserIds,
  initialPermission,
  onSearch,
  onCancel,
  scopeOverride
}) => {
  const [selectedHostIds, setSelectedHostIds] = useState(initialHostIds);
  const [selectedOwnerIds, setSelectedOwnerIds] = useState(initialOwnerIds);
  const [selectedUserIds, setSelectedUserIds] = useState(initialUserIds);
  const [selectedPermission, setSelectedPermission] = useState(initialPermission);
  const onApply = () => {
    onSearch({
      selectedHostIds,
      selectedOwnerIds,
      selectedUserIds,
      selectedPermission
    });
  };
  const onReset = () => {
    setSelectedHostIds([]);
    setSelectedOwnerIds([]);
    setSelectedUserIds([]);
    setSelectedPermission('');
  };
  return <>
      <Filters selectedHostIds={selectedHostIds} setSelectedHostIds={setSelectedHostIds} selectedOwnerIds={selectedOwnerIds} setSelectedOwnerIds={setSelectedOwnerIds} selectedUserIds={selectedUserIds} setSelectedUserIds={setSelectedUserIds} selectedPermission={selectedPermission} setSelectedPermission={setSelectedPermission} scopeOverride={scopeOverride} />

      <Footer>
        <ResetButtonWrapper>
          <MinimalButton onClick={onReset}>
            {I18n.t('publisher.event_types.filters.reset')}
          </MinimalButton>
        </ResetButtonWrapper>
        <Button size="small" decoration="secondary-outline" onClick={onCancel}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button size="small" onClick={onApply}>
          {I18n.t('publisher.action.apply')}
        </Button>
      </Footer>
    </>;
};

require("./dropdown_content.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./dropdown_content.js");